import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ApiMethod } from '../apimethods/api-method';
import * as Highcharts from 'highcharts';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
declare var $;

@Component({
  selector: 'pra-services',
  templateUrl: './pra-services.component.html',
  styleUrls: ['./pra-services.component.css']
})
export class PRAServicesComponent implements OnInit {

  SummaryList: any;

  @ViewChild('dataTable', { static: false }) table;
  dataSet: any; dataTable: any;

  @ViewChild('dataTablePA', { static: false }) tablePA;
  dataSetPA: any; dataTablePA: any;

  ListTitle: string = ''; summaryH5Title: string = 'All';
  PublisherList: any; TaskList: any; ReasonList: any;
  UserList: any; FilterUserList: any; UserLeadList: any;
  UserList1: any; UserList2: any;
  PraUserList: any;
  monthwiseSummary: any;
  currentDay: string;
  prasProductivity: any; praName: string = 'Over All';
  public summaryTab: boolean = GlobalConstants.CheckMetadataView('PRASummaryTab');
  public kpiTab: boolean = GlobalConstants.CheckMetadataView('PRAKPITab');
  public listTab: boolean = GlobalConstants.CheckMetadataView('PRAListTab');
  public uploadICon: boolean = GlobalConstants.CheckMetadataView('PRAServiceUploadIcon');
  taskTypeCheck: string = 'Select';

  constructor(private router: Router) {
    let _date = new Date();
    this.currentDay = GlobalConstants.FromateDateName(_date);


  }

  ResizeHieght() {
    $('#divtabPRADatewise,#divtabJournalDatewise').css('height', (GlobalConstants.size.height - 200));
    $('#tabKPI,#tabDashboard').css('height', (GlobalConstants.size.height) - 50);
    $('#divSummaryitemDash').css('height', (GlobalConstants.size.height) - 100);
    $('#divFormData').css('height', (GlobalConstants.size.height) - 250);
    $('#divSummaryitem,#divKpiData').css('height', (GlobalConstants.size.height) - 150);
    $('#divFilterPanel').css('height', (GlobalConstants.size.height));
    /*$('#txtNotes,#txtQcComments').css('height', (GlobalConstants.size.height) - 450);*/
  }

  ngOnInit() {
    customfunctions.SetDateValues("#txtFromDt", "#txtToDt");
    customfunctions.SetDateValues("#txtFromDt2", "#txtToDt2");
    customfunctions.SetTodayDateValues("#txtFromDtList");
    customfunctions.SetTodayDateValues("#txtToDtList");

    customfunctions.SetCurrentMonthDateValues("#txtPopupFromDt", "#txtPopupToDt");

    this.ResizeHieght();

    //$("#ddlTaskName").select2({
    //  placeholder: "Select Task Name", dropdownParent: "#divFormPanel", tags: true
    //});


    $("#ddlPopupManuscript,#ddlPopupJournal,#ddlPopupTaskName,#ddlPopupStatus").select2({
      placeholder: "Select Manuscript", dropdownParent: "#myModal_AllocatedTask"
    });
    $("#ddlPopupManuscript,#ddlPopupJournal,#ddlPopupTaskName,#ddlPopupStatus").val([]).trigger("change");

    $("#ddlFilterManuscript").select2({
      placeholder: "Select Manuscript", dropdownParent: "#divFilterPanel"
    }); $("#ddlFilterManuscript").val([]).trigger("change");

    $("#ddlFilterJournal").select2({
      placeholder: "Select Manuscript", dropdownParent: "#divFilterPanel"
    });

    $("#ddlFilterJournal,#ddlFilterTaskName,#ddlFilterStatus").select2({
      placeholder: "Select", dropdownParent: "#divFilterPanel"
    });

    //$("#ddlFilterTeamLead,#ddlFilterAllocatedUser,#ddlFilterJournal,#ddlFilterTaskName,#ddlFilterStatus").select2({
    //  placeholder: "Select Manuscript", dropdownParent: "#divFilterPanel"
    //});

    this.GetJournalList();
    this.GetDashboardDetails();
    this.GetSummartItem();
    this.GetPublisherList(); this.GetPraUserList();
    this.GetUserLeadList();
    this.GetTaskList(); this.GetPraServices();
    this.GetUserList(1);
    this.GetFilterUserList();

    if (this.kpiTab == true && this.summaryTab == true && this.listTab == true) {
      $('#liSummaryTab a.nav-link').addClass('active');
      $('#tabDashboard').addClass('active');
    }
    else if (this.kpiTab == true && this.summaryTab == true && this.listTab == false) {
      $('#liKpiTab a.nav-link').addClass('active');
      $('#tabKPI').addClass('active');
    }
    else if (this.kpiTab == false && this.summaryTab == false && this.listTab == true) {
      $('a[href="#tabListData"]').click();
      this.GetSummaryData('List');
      //$('#liListTab a.nav-link').addClass('active');
      //$('#tabListData').addClass('active');
    }

    setInterval(function () {
      $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    }, 200);
  }

  ngAfterViewChecked(): void {
    this.ResizeHieght();
  }

  ChangeMonthRange(tabName = '') {
    if (tabName == 'Dashboard') { 
      if ($('#ddlKPIMonthRange').val() == -1) {
        $('#divKpiFromDate,#divKpiToDate').show();
      }
      else {
        $('#divKpiFromDate,#divKpiToDate').hide();
      }
    }
    else {
      if ($('#ddlKPIMonthRange2').val() == -1) {
        $('#divKpiFromDate2,#divKpiToDate2').show();
      }
      else {
        $('#divKpiFromDate2,#divKpiToDate2').hide();
      }
    }
  }

  GetSummaryData(tabType, IsLoadingImg = true, filterPanel = false): void {
    if (tabType === undefined) {
      tabType = $("li.active").data('tabname');
    }
    this.GetPraServices(this.ListTitle, false, filterPanel);
    this.GetDashboardDetails();
    this.GetSummartItem();

  }

  JournalList: any;
  GetJournalList() {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: $("#ddlKPIPulisher").val(),
    };
    ApiMethod.postMethod('pra/PRAJournalConfig', dashboardPostData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.JournalList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  PrasDatewiseAllocated;

  DashboardData: any;
  GetDashboardDetails(): void {
    $("#LoadingImage").show();

    let _teamLead = true;
    let _allocatedUser = $('#ddlKPITeamLead').val();
    if ($('#ddlKPIAllocatedUser').val() != 0) {
      _allocatedUser = $('#ddlKPIAllocatedUser').val();
      _teamLead = false;
    }

    let _teamLead1 = true;
    let _allocatedUser1 = $('#ddlKPITeamLead1').val();
    if ($('#ddlKPIAllocatedUser1').val() != 0) {
      _allocatedUser1 = $('#ddlKPIAllocatedUser1').val();
      _teamLead1 = false;
    }

    let _teamLead2 = true;
    let _allocatedUser2 = $('#ddlKPITeamLead2').val();
    if ($('#ddlKPIAllocatedUser2').val() != 0) {
      _allocatedUser2 = $('#ddlKPIAllocatedUser2').val();
      _teamLead2 = false;
    }

    this.praName = $('#ddlKPIAllocatedUser option:selected').text();

    var dashboardPostData = {
      LoginId: localStorage.aLoginID,
      PublisherId: $("#ddlKPIPulisher").val(),
      AllocatedUserId: _allocatedUser,
      FromDate: $('#txtFromDt').val(),
      ToDate: $('#txtToDt').val(),
      MonthRange: $("#ddlKPIMonthRange").val(),
      TeamLead: _teamLead,

      PublisherId1: $("#ddlKPIPulisher1").val(),
      AllocatedUserId1: _allocatedUser1,
      FromDate1: $('#txtFromDt').val(),
      ToDate1: $('#txtToDt').val(),
      MonthRange1: $("#ddlKPIMonthRange1").val(),
      TeamLead1: _teamLead1,

      PublisherId2: $("#ddlKPIPulisher2").val(),
      AllocatedUserId2: _allocatedUser2,
      FromDate2: $('#txtFromDt2').val(),
      ToDate2: $('#txtToDt2').val(),
      MonthRange2: $("#ddlKPIMonthRange2").val(),
      TeamLead2: _teamLead2
    };
    ApiMethod.postMethod('/api/pra/dashboard', dashboardPostData).subscribe(
      resonse => {
        try {

          let data = resonse.prasdatewiseallocated;

          let thAdded = 0; let tableTh = $('#TblDatewise thead'); let table = $('#TblDatewise tbody');
          // Clear existing rows if necessary
          tableTh.empty(); table.empty();
          $.each(data, function (index, item) {
            let thRow = $('<tr >'); let row = $('<tr>');
            $.each(item, function (key, value) {
              if (thAdded == 0) {
                thRow.append($('<th style="text-align:center;background: #b6cff9 !important;position: sticky;top: 0;">').text(key)); // Add headers only once
              }
              if (key === 'PRA Name') {
                let displayValue = value ?? "Unallocated";
                // Create clickable span
                let $span = $('<span>')
                  .addClass('pra-link')
                  .attr('style', 'color: blue;cursor: pointer;')
                  .attr('title', 'View Allocated Task List')
                  .text(displayValue)
                  .on('click', function () {
                    localStorage.praname = displayValue;
                    $('#btnShowAllocated').trigger('click');
                  });

                if (displayValue == 'Grand Total') {
                  $span = 'Grand Total';
                }

                row.append($('<td style="text-align:center;">').append($span));
              } else {
                row.append($('<td style="text-align:center;">').text(value));
              }


            });
            if (thAdded == 0) {
              tableTh.append(thRow); // Append header row
              thAdded = 1;
            }
            table.append(row); // Append data row
          });


          let datajrl = resonse.journaldatewiseallocated;

          let thAdded1 = 0; let tableTh1 = $('#TblJrlDatewise thead'); let table1 = $('#TblJrlDatewise tbody');
          // Clear existing rows if necessary
          tableTh1.empty(); table1.empty();
          $.each(datajrl, function (index, item) {
            let thRow1 = $('<tr >'); let row1 = $('<tr>');
            $.each(item, function (key, value) {
              if (thAdded1 == 0) {
                thRow1.append($('<th style="text-align:center;background: #b6cff9 !important;position: sticky;top: 0;">').text(key)); // Add headers only once
              }
              row1.append($('<td style="text-align:center;">').text(value)); // Add data cells

            });
            if (thAdded1 == 0) {
              tableTh1.append(thRow1); // Append header row
              thAdded1 = 1;
            }
            table1.append(row1); // Append data row
          });

          const style = document.createElement('style');
          style.innerHTML = `
            .equal-width-table td:first-child,
            .equal-width-table th:first-child {
              text-align: left !important;
              font-weight: bold;
            }`;
          document.head.appendChild(style);

          this.prasProductivity = resonse.praproductivity;
          this.DashboardData = resonse.dashboard;
          this.monthwiseSummary = resonse.dashboard;
          let asummaryList = resonse.dashboard;
          let kpiData = resonse.kpidashboard;
          let kpiTracker = resonse.kpitracker;
          let empKpi = resonse.empKpi;

          this.GetKPIProcess(asummaryList, kpiData, kpiTracker);

          //Task Name List
          let chartACLData: any = []; let chartFILData: any = []; let chartPCLData: any = [];
          let chartDataAllocate: any = []; let chartDataCom: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          //Late Task List
          let chartDataACLT: any = []; let chartDataFILT: any = []; let chartDataPCLT: any = [];
          let chartLTSeriesList: any = [];


          //TAT OA Admin CheckList
          let chartOAACLData: any = []; let chartOAPCLData: any = [];
          let chartNOAACLData: any = []; let chartNOAPCLData: any = [];
          let chartTATSeriesList: any = [];

          //FeedbackType List
          let chartFIData: any = []; let chartFEData: any = [];
          let chartFTSeriesList: any = [];

          $(asummaryList).each(function (index, val) {
            let _monthYear = val.CurrentMonth + '-' + val.CurrentYear;
            chartDataAllocate.push({ y: val.Wip, name: _monthYear });
            chartDataCom.push({ y: val.Completed, name: _monthYear });
            monthList.push(_monthYear);

            //Task Summary List
            chartACLData.push({ y: val.AdminChecklist, name: _monthYear });
            chartFILData.push({ y: val.FormsIn, name: _monthYear });
            chartPCLData.push({ y: val.ProductionChecklist, name: _monthYear });


            //Late Task  List
            chartDataACLT.push({ y: val.LateAdminChecklist, name: _monthYear });
            chartDataFILT.push({ y: val.LateFormsIn, name: _monthYear });
            chartDataPCLT.push({ y: val.LateProductionChecklist, name: _monthYear });


            //TAT OA Admin Check List
            chartOAACLData.push({ y: val.AdminChecklist_OA_TAT, name: _monthYear });
            chartOAPCLData.push({ y: val.ProductionChecklist_OA_TAT, name: _monthYear });
            chartNOAACLData.push({ y: val.AdminChecklist_NonOA_TAT, name: _monthYear });
            chartNOAPCLData.push({ y: val.ProductionChecklist_NonOA_TAT, name: _monthYear });

            //FeedbackType List
            chartFIData.push({ y: val.AdminChecklist_Internal, name: _monthYear });
            chartFEData.push({ y: val.AdminChecklist_External, name: _monthYear });
          });

          //Task Summary
          chartSeriesList.push({
            name: 'Admin Check', data: chartACLData, color: '#3194fd',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Forms In', data: chartFILData, color: '#35288b',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Production Check', data: chartPCLData, color: '#13830c',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });

          //Late Task List
          chartLTSeriesList.push({
            name: 'Admin Check', data: chartDataACLT, color: '#8f8b8b',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartLTSeriesList.push({
            name: 'Forms In', data: chartDataFILT, color: '#9d8608',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartLTSeriesList.push({
            name: 'Production Check', data: chartDataPCLT, color: '#cd7f32',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });

          this.LoadChartData(chartDataAllocate, chartDataCom, monthList);

          //Task Summary chart and Late Task List
          this.LoadBarChartData(monthList, chartSeriesList, chartLTSeriesList);

          //TAT OA Admin Check List
          chartTATSeriesList.push({
            name: 'OA TAT Admin Check', data: chartOAACLData, color: '#00766f',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartTATSeriesList.push({
            name: 'OA TAT Production Check', data: chartOAPCLData, color: '#544fc5',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartTATSeriesList.push({
            name: 'Non-OA TAT Admin Check', data: chartNOAACLData, color: '#3194fd',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartTATSeriesList.push({
            name: 'Non-OA TAT Production Check', data: chartNOAPCLData, color: '#1c74bd',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });

          //TAT OA Admin Check List
          this.LoadTATChartData(monthList, chartTATSeriesList);

          //Emp Kpi Dashboard
          let chartColCategory: any = []; let chartColSeriesList: any = [];
          let _empKpiCategory = JSON.parse(empKpi[0].EmpCategory); let _empKpiSeries = JSON.parse(empKpi[0].EmpKpiData);

          $(_empKpiCategory).each(function (index, val) {
            chartColCategory.push(val.name);
          });

          let _taskAssigned: any = []; let _taskAttempted: any = []; let _productivity: any = [];
          $(_empKpiSeries).each(function (index, val) {
            _taskAssigned.push({ name: val.name, y: val.TaskAssigned, percent: val.Productivity });
            _taskAttempted.push({ name: val.name, y: val.TaskAttempted, percent: val.Productivity });
            _productivity.push({ name: val.name, y: val.Productivity, percent: val.Productivity });
          });

          chartColSeriesList.push({
            name: 'Productivity %', data: _productivity, color: '#3194fd',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y} %'
            }
          });
          chartColSeriesList.push({
            name: 'Task Assigned', data: _taskAssigned, color: '#544fc5',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartColSeriesList.push({
            name: 'Task Attempted', data: _taskAttempted, color: '#00766f',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });

          this.LoadColChartData(chartColCategory, chartColSeriesList);

          //FeedbackType List
          chartFTSeriesList.push({
            name: 'Internal', data: chartFIData, color: '#6b8abc',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartFTSeriesList.push({
            name: 'External', data: chartFEData, color: '#7b14fa',
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });

          this.LoadFTChartData(monthList, chartFTSeriesList);

          $("#LoadingImage").hide();
        } catch (e) {
          ngswal("Warning !", e, "warning");
          $("#LoadingImage").hide();
        }
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });
  }


  GetKPIProcess(summary, kpidash, kpitrack) {
    let _style = 'style="background: linear-gradient(90deg, rgb(122 116 226) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%);color: #FFF;border-radius: 15px 0;"';
    let _style1 = 'style="font-weight:bold;background: rgb(238,174,202);background: radial-gradient(circle, rgb(224 215 219) 0%, rgba(148, 187, 233, 1) 100%);border-radius: 0 15px;"';

    let _panelData = '<div class="row">';
    let _countStyle = 'style="float:right;font-size:18px"';


    if (kpitrack.length == 0) {
      _panelData += '<center><h4>No Data Found</h4></center>';
    }
    $(kpitrack).each(function (index, val) {
      _panelData += '<div class=col-2>';
      _panelData += '<td>';
      _panelData += '<center><h5 ' + _style + '>' + val.MonthYear + '</h5></center><hr/>';
      _panelData += '<h6>Productivity <span ' + _countStyle + ' >' + val.Productivity + '%</span></h6>';
      _panelData += '<h6>Attempted in Month  <span ' + _countStyle + ' >' + val.TaskCount + '</span></h6>';

      var _taskList = kpidash.filter(a => a.MonthYear == val.MonthYear);

      _panelData += '<center><h6 ' + _style1 + '>Task bifurcation</h6></center>';
      $(_taskList).each(function (index1, val1) {
        _panelData += '<h6>' + val1.TaskName + '  <span style="float:right">' + val1.TaskCount + '</span></h6>';
      });
      _panelData += '</div>';
    });

    _panelData += '</div>';

    $('#divKpiData').html(_panelData);
  }

  //EmpKPI Chart
  highchartsCol: typeof Highcharts = Highcharts; chartOptionsCol;
  LoadColChartData(categoryList, chartSeriesList) {
    //Column Chart
    this.highchartsCol = Highcharts;
    this.chartOptionsCol = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'User KPI'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      yAxis: {
        //stackLabels: {
        //  style: {
        //    color: 'black'
        //  },
        //  enabled: true,
        //  formatter: function () {
        //    console.log(this); console.log(this.axis.series.name);
        //    return this.axis.series.name;
        //  },
        //}
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: chartSeriesList
    };
  }

  //TAT KPI Chart
  highchartsColTAT: typeof Highcharts = Highcharts; chartOptionsColTAT;

  highchartsColOAAC: typeof Highcharts = Highcharts; chartOptionsColOAAC;
  highchartsColOAPC: typeof Highcharts = Highcharts; chartOptionsColOAPC;
  highchartsColNOAAC: typeof Highcharts = Highcharts; chartOptionsColNOAAC;
  highchartsColNOAPC: typeof Highcharts = Highcharts; chartOptionsColNOAPC;

  LoadTATChartData(categoryList, chartSeriesList) {
    //Column Chart
    this.highchartsColTAT = Highcharts;
    this.chartOptionsColTAT = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'TAT Task List'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: chartSeriesList,
    };

    //OA Admin CheckList
    this.highchartsColOAAC = Highcharts;
    this.chartOptionsColOAAC = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'OA TAT : Admin Checklist'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: [chartSeriesList[0]],
    };

    //OA Production CheckList
    this.highchartsColOAPC = Highcharts;
    this.chartOptionsColOAPC = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'OA TAT : Production Checklist'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: [chartSeriesList[1]],
    };

    //OA Admin CheckList
    this.highchartsColNOAAC = Highcharts;
    this.chartOptionsColNOAAC = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'Non-OA TAT : Admin Checklist'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: [chartSeriesList[2]],
    };

    //Non-OA Production CheckList
    this.highchartsColNOAPC = Highcharts;
    this.chartOptionsColNOAPC = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'Non-OA TAT : Production Checklist'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: [chartSeriesList[3]],
    };
  }

  //Feedback Type Chart
  highchartsColFT: typeof Highcharts = Highcharts; chartOptionsColFT;
  LoadFTChartData(categoryList, chartSeriesList) {
    //Column Chart
    this.highchartsColFT = Highcharts;
    this.chartOptionsColFT = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'Feedback Type'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      legend: {
        reversed: true
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{category}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: chartSeriesList,
    };
  }

  //Task Summary Chart and Late Task List
  highchartsBar: typeof Highcharts = Highcharts; chartOptionsBar;
  highchartsBarLT: typeof Highcharts = Highcharts; chartOptionsBarLT;
  LoadBarChartData(categoryList, chartSeriesList, chartLTSeriesList) {
    //Task Summry Column Chart
    this.highchartsBar = Highcharts;
    this.chartOptionsBar = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'Task Summary'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        }
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: chartSeriesList
    };

    //Late Task List
    this.highchartsBarLT = Highcharts;
    this.chartOptionsBarLT = {
      chart: {
        type: 'bar',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        }
      },
      title: {
        text: 'Late Task'
      },
      xAxis: {
        categories: categoryList,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        }
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      tooltip: {
        headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
          '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
      },
      series: chartLTSeriesList
    };

  }

  highchartsArea: typeof Highcharts = Highcharts; chartOptionsArea;
  LoadChartData(chartDataAllocate, chartDataComeleted, monthList): void {
    try {
      //Area Chart
      this.highchartsArea = Highcharts;
      this.chartOptionsArea = {
        chart: {
          type: 'area',
          style: {
            fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
          }
        },
        title: {
          text: 'Monthly Summary'
        },
        xAxis: {
          categories: monthList,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: [
          {
            name: 'Total',
            data: chartDataAllocate,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            },
            color: '#3194fd'
          },
          {
            name: 'Completed',
            data: chartDataComeleted,
            dataLabels: {
              enabled: true,
              color: 'green',
              format: '{point.y}'
            },
            color: '#2bc95e'
          }
        ],
      };
    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }

  highchartsPie: typeof Highcharts = Highcharts; chartOptions;
  LoadChartTask(chartData) {
    //Pie Chart
    this.highchartsPie = Highcharts;
    this.chartOptions = {
      chart: {
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        plotBorderWidth: null,
        plotShadow: false
      },
      title: {
        text: 'Task Summary'
      },
      series: [{
        type: 'pie',
        name: "count",
        data: chartData
      }]
    };
  }

  ChangeTATChartView(view): void {
    $('.TATView').hide();
    $('#divTAT' + view).show();
  }

  GetSummartItem(): void {
    $("#LoadingImageDashSummary").show();
    ApiMethod.getMethod('/api/pra/summarylist/' + localStorage.aLoginID + '/' + localStorage.aPubID).subscribe(
      result => {
        $("#LoadingImageDashSummary").hide();
        this.SummaryList = result.datalist;

        let chartData: any = []; let categoryList: any = [];
        $(this.SummaryList).each(function (index, val) {
          chartData.push({ y: val.SummaryCount, name: val.SummaryName });
          categoryList.push(val.SummaryName);
        });

        this.LoadChartTask(chartData);


      }, error => {
        $("#LoadingImageDashSummary").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetPublisherList(): void {
    ApiMethod.getMethod('/api/pra/publist/' + localStorage.aLoginID).subscribe(
      result => {
        this.PublisherList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetUserLeadList(): void {
    ApiMethod.getMethod('/api/pra/userlist/true/0').subscribe(
      result => {
        this.UserLeadList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetUserList(load = 0): void {
    let leadId = load === 1 ? $('#ddlKPITeamLead1').val() :
      load === 2 ? $('#ddlKPITeamLead2').val() :
        $('#ddlKPITeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/' + leadId).subscribe(
      result => {
        if (load == 1) {
          this.UserList1 = result.datalist;
        }
        if (load == 2) {
          this.UserList2 = result.datalist;
        }
        else {
          this.UserList = result.datalist;
          this.UserList1 = result.datalist;
          this.UserList2 = result.datalist;
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetFilterUserList(): void {
    let leadId = $('#ddlFilterTeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/' + leadId).subscribe(
      result => {
        this.FilterUserList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetPraUserList(): void {
    let leadId = $('#ddlKPITeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/0').subscribe(
      result => {
        this.PraUserList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetTaskList(): void {
    ApiMethod.getMethod('/api/pra/tasklist').subscribe(
      result => {
        this.TaskList = result.datalist;
        this.ReasonList = result.reasonList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  LoadGridByType(filter): void {
    $('h6.h5active').removeClass('h5active');

    let summarTr = $('#span' + filter);
    $(summarTr).addClass('h5active');

    this.summaryH5Title = filter;
    this.ListTitle = $(summarTr).attr('data-summaryname');

    this.GetPraServices(filter);

  }

  GetPraServices(filterType = 'Current', skipLoading = false, filterPanel = false) {
    $("#LoadingImage").show();
    let pubId = localStorage.aPubID;
    if (filterPanel == true && $("#ddlFilterPulisher").val() != 0) {
      pubId = $("#ddlFilterPulisher").val();
    }

    let _teamLead = true;
    let _allocatedUser = $('#ddlFilterTeamLead').val();
    if ($('#ddlFilterAllocatedUser').val() != 0) {
      _allocatedUser = $('#ddlFilterAllocatedUser').val();
      _teamLead = false;
    }
    let _journalCode = 'All';
    let _dateType = ''; let _manuscriptList = ''; let _taskName = 'All'; let _status = 'All';
    if (filterPanel == true) {
      _dateType = $("#ddlFilterDateType").val();
      _journalCode = $("#ddlFilterJournal").val();

      if ($("#ddlPopupManuscript").val() != null) {
        _manuscriptList = $("#ddlPopupManuscript").val().toString();
      }
      _taskName = $("#ddlFilterTaskName").val();
      _status = $("#ddlFilterStatus").val();
    }

    var data = {
      LoginId: localStorage.aLoginID,
      PublisherId: pubId,
      FromDate: $("#txtFromDtList").val(),
      ToDate: $("#txtToDtList").val(),
      FilterType: filterType,
      FilterPanel: filterPanel,
      TeamLead: _teamLead,
      AllocatedUserId: _allocatedUser,
      DateType: _dateType,
      JournalCode: $("#ddlFilterJournal").val() ? $("#ddlFilterJournal").val().join(',') : "All",
      ManuscriptList: _manuscriptList,
      TaskName: $("#ddlFilterTaskName").val() ? $("#ddlFilterTaskName").val().join(',') : "All",
      CurrentStatus: $("#ddlFilterStatus").val() ? $("#ddlFilterStatus").val().join(',') : "All",
    }
    ApiMethod.postMethod('api/pralist', data).subscribe(
      response => {

        let summarTr = $('#span' + filterType).closest('tr');
        $(summarTr).find('h5').addClass('h5active');

        this.dataSet = JSON.stringify(response.datalist); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = response.collist; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 200);
        dataItem.modulename = 'PRAServices';
        dataItem.aNewButtonName = 'BtnAddNew';
        if (this.uploadICon) {
          dataItem.aNewButtonName2 = 'btnUploadServices';
          dataItem.aNewButtonToolTip2 = 'Upload Services';
        }
        dataItem.infoPopupID = 'Id';
        dataItem.isDefault = false;
        dataItem.colsetting = false;
        dataItem.filterPanel = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });

  }

  ShowFilterPanel() {
    $('#divFilterPanel').show();
  }
  HideFilterPanel() {
    $('#divFilterPanel').hide();
  }

  GetResetFilter() {
    // Set today's date
    const dateFields = ["#txtFromDtList", "#txtToDtList"];
    dateFields.forEach(id => customfunctions.SetTodayDateValues(id));

    // Dropdowns to reset to 'All'
    const allDropdowns = [
      "#ddlFilterJournal",
      "#ddlFilterTaskName",
      "#ddlFilterStatus"
    ];
    allDropdowns.forEach(id => $(id).val('All').change());

    // Set DownloadDate specifically
    $('#ddlFilterDateType').val('DownloadDate').change();
    $('#ddlFilterTeamLead,#ddlFilterAllocatedUser').val(0).change();
  }

  ResetFilter(type = 0): void {
    //$('#btnLoadList').show();
    if (type == 0) {
      $('#ddlKPIMonthRange').val(0).change();
      $("#ddlPublisher").val(0).change();
      $('#ddlKPITeamLead').val(0).change();
      $('#ddlKPIAllocatedUser').val(0).change();
      customfunctions.SetDateValues("#txtFromDt", "#txtToDt");
    }
    if (type == 1) {
      $('#ddlKPIPulisher1').val(0).change();
      $("#ddlKPITeamLead1").val(0).change();
      $('#ddlKPIAllocatedUser1').val(0).change();
      customfunctions.SetDateValues("#txtFromDt2", "#txtToDt2");
    }
    this.GetDashboardDetails();
    this.GetSummartItem();
    this.GetPraServices(this.ListTitle);
  }

  ShowAddForm() {
    this.clearData();
    $('.divAddMode').show();
    if (localStorage.aEID != '0') {
      $('.divAddMode').hide();
      $('.divUpdateMode').show();
      $("#LoadingImage").show();
      ApiMethod.getMethod('/api/pra/populate/' + localStorage.aEID).subscribe(
        result => {

          $('.disabledControls').prop("disabled", true);
          let dataitem = result.datalist;
          let allocationList = result.allocationlist;

          $("#ddlPublisher").val(dataitem.PublisherId).change();
          $("#txtJournal").val(dataitem.JournalCode);
          $("#txtManuscriptId").val(dataitem.ManuscriptId);
          $("#txtManuscriptTitle").val(dataitem.ManuscriptTitle);
          $("#txtManuscriptType").val(dataitem.ManuscriptType);
          if (dataitem.LastDownloadDate == null) {
            $("#txtDownloadDate").val(GlobalConstants.SetValue_FormatDate(dataitem.DownloadDate));
          }
          else {
            $("#txtDownloadDate").val(GlobalConstants.SetValue_FormatDate(dataitem.LastDownloadDate));
          }
          $("#txtSubmissionDate").val(GlobalConstants.SetValue_FormatDate(dataitem.SubmissionDate));
          $("#txtCompletionDate").val(GlobalConstants.SetValue_FormatDate(dataitem.CompletionDate));
          $("#ddlResubmit").val(dataitem.EntryMode).change();
          $("#ddlTaskName").val(dataitem.TaskName).change();

          if (dataitem.TaskName == 'Admin Checklist') {
            $('#divTaskType').show();
            if (dataitem.TaskType != null) {
              $("#ddlTaskType").val(dataitem.TaskType).change();
              this.taskTypeCheck = dataitem.TaskType;
            }
            else {
              $("#ddlTaskType").val('Select').change();
              this.taskTypeCheck = 'Select';
            }
          }
          else {
            $('#divTaskType').hide();
          }

          if (dataitem.CurrentStatus == 'NA') {
            $("#ddlStatus").val('Not Applicable').change();
          }
          else {
            $("#ddlStatus").val(dataitem.CurrentStatus).change();
          }
          if (dataitem.Unsubmitted == null || dataitem.Unsubmitted == '') {
            $("#ddlUnsubmitted").val('Select').change();
          }
          else {
            $("#ddlUnsubmitted").val(dataitem.Unsubmitted).change();
          }
          $("#txtSubmittingAuthor").val(dataitem.SubmittingAuthor);
          $("#txtCountrySubmittingAuthor").val(dataitem.CountrySubmittingAuthor);
          $("#txtEditorInChief").val(dataitem.EditorInChief);
          $("#txtEditor").val(dataitem.Editor);



          $("#ddlAllocatedUser").val(dataitem.AllocatedUserId).change();

          $("#txtNotes").val(dataitem.Notes);


          if (dataitem.FeedbackType == null) {
            $("#ddlFeedbackType").val('Select').change();
          }
          else {
            $("#ddlFeedbackType").val(dataitem.FeedbackType).change();
          }
          $("#txtFeedbackDate").val(GlobalConstants.SetValue_FormatDate(dataitem.FeedbackDate));

          if (dataitem.QcComments != null && dataitem.QcComments.trim() !== "") {
            $("#txtQcComments,#ddlFeedbackType,#txtFeedbackDate").prop("disabled", true);
          } else {
            $("#txtQcComments,#ddlFeedbackType,#txtFeedbackDate").prop("disabled", false);
          }
          $("#txtQcComments").val(dataitem.QcComments);

          if (dataitem.QueryComments != null && dataitem.QueryComments.trim() !== "") {
            $("#txtQueryComments").prop("disabled", true);
          } else {
            $("#txtQueryComments").prop("disabled", false);
          }

          var queryComments = dataitem.QueryComments || "";


          if ($.trim(queryComments) === "") {
            $("#txtQueryComments").val("");
          } else {
            queryComments = "Query Date: " + (dataitem.QueryDate || "") + "\n\n" + queryComments
          }

          var resolvedDateText = dataitem.QueryResolvedDate ? "Resolved Date: " + dataitem.QueryResolvedDate : "";

          var responseText = dataitem.QueryResponse ? "Response: " + dataitem.QueryResponse : "";

          if (resolvedDateText && queryComments.indexOf(resolvedDateText) === -1) {
            queryComments += "\n\n" + resolvedDateText;
          }

          if (responseText && queryComments.indexOf(responseText) === -1) {
            queryComments += "\n\n" + responseText;
          }

          $("#txtQueryComments").val(queryComments);


          $("#ddlReasonList").val(dataitem.ReasonId == null ? 0 : dataitem.ReasonId).change();

          $('#TblAllocationList tbody tr').remove();

          let trSNo = 0;
          let th = ''; let tr = '';
          th += '<tr>';
          th += '<th>#</th>';
          th += '<th>Allocated User</th>';
          th += '<th>Start Date</th>';
          th += '<th>Complete Date</th>';
          th += '<th>Hold Date</th>';
          th += '<th>Resume Date</th>';
          th += '</tr>';
          $('#TblAllocationList thead').html(th);
          $.each(allocationList, function (e, val) {
            trSNo = (e + 1);
            tr = '<tr>';
            tr += '<td>' + trSNo + '</td>';
            tr += '<td>' + val.AllocatedUser + '</td>';
            tr += '<td>' + GlobalConstants.FormatDateTime(val.StartDate) + '</td>';
            tr += '<td>' + GlobalConstants.FormatDateTime(val.CompleteDate) + '</td>';
            tr += '<td>' + GlobalConstants.FormatDateTime(val.HoldDate) + '</td>';
            tr += '<td>' + GlobalConstants.FormatDateTime(val.ResumeDate) + '</td>';
            tr == '</tr>';
            $('#TblAllocationList tbody').append(tr);
          });

          if ($("#ddlStatus").val() == 'Completed') {
            $('.divStartPRA').hide();
            $('.divUpdatePRA').hide();
          }

          else {
            if ($("#ddlStatus").val() == 'Select' || GlobalConstants.isNullCheck($("#ddlStatus").val()) == '') {
              $('.divStartPRA').show();
              $('.divUpdatePRA').hide();
            }
            else {
              $('.divStartPRA').hide();
              $('.divUpdatePRA').show();
            }
          }

          $('#divMainPanel').hide();
          $('#divFormPanel').show();

          //Check Validation enable em tag
          this.ChangeStatus();
          this.ChangeReason();
          this.ChangeFeedback();
          this.ChangeUnsubmitted();

          $("#LoadingImage").hide();

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Warning !", error, "warning");
        });
    }
    else {
      $('.disabledControls').prop("disabled", false);
      $('#divMainPanel').hide();
      $('#divFormPanel').show();
    }
  }

  ChangeUnsubmitted() {
    $('.emUnsubmitted').hide();
    if ($("#ddlUnsubmitted").val() == 'Yes') {
      $('.emUnsubmitted').show();
    }
  }

  ChangeTaskName() {
    if ($("#ddlTaskName").val() == 'Admin Checklist') {
      $('#divTaskType').show();
    }
    else {
      $('#divTaskType').hide();
    }
    $('#ddlTaskType').val('Select').change();
  }

  ChangeTaskType() {
    if (this.taskTypeCheck != 'Select') {
      ngswal("Warning !", 'Selected for a manuscript that has already been marked as a new submission in WMS', "warning");
    }
  }

  ChangeStatus() {
    if ($("#ddlStatus").val() == 'Problem') {
      $('#divReasonList').show();
    }
    else {
      $('#divReasonList').hide();
    }

    if ($("#ddlStatus").val() == "Completed") {
      $('.emCompleted').show();
    }
    else if ($("#ddlStatus").val() == "Saved") {
      $('.emSaved').show();
    }
    else {
      $('.emCompleted').hide();
    }
    if ($('#ddlStatus').val() == 'Late' || $('#ddlStatus').val() == 'Not Applicable' || $('#ddlStatus').val() == 'Future') {
      $('#emNotes').show();
    }
    else {
      $('#emNotes').hide();
    }

  }

  ChangeReason() {
    //Other (PRA to enter relevant remarks) - 29
    if ($("#ddlReasonList").val() == 29) {
      $('#emNotes').show();
    }
    else {
      $('#emNotes').hide();
    }
  }
  ChangeFeedback() {
    if ($('#ddlFeedbackType').val() != "Select" || $('#txtQcComments').val() != "" || $('#txtFeedbackDate').val() != "") {
      $('.emFeedback').show();
    }
    else {
      $('.emFeedback').hide();
    }
  }

  CloseForm() {
    $('#divReasonList').hide();
    $('.divUpdateMode').hide();
    $('#divMainPanel').show();
    $('#divFormPanel').hide();
    //this.GetPraServices(this.ListTitle);
  }

  UpdateStatus(type) {
    let _status = $('#ddlStatus').val(); let _allocateduser = $('#ddlAllocatedUser').val();
    $('#ddlStatus').val(type).change();
    this.UpdateServices(true);
  }

  UpdateServices(updateMode = false) {
    //if ($("#txtQcComments").val() == '') {
    //  $("#txtQcComments").val('--');
    //}
    //if ($("#ddlPublisher").val() == '0') {
    //  ngswal("Failed !", "Please select pulisher", "error");
    //}
    if ($("#txtDownloadDate").val() == '') {
      ngswal("Failed !", "Please select Download Date", "error");
    }
    else if ($("#txtJournal").val() == '') {
      ngswal("Failed !", "Please update Journal", "error");
    }
    else if ($("#ddlTaskName").val() == '0') {
      ngswal("Failed !", "Please select Task Name", "error");
    }
    else if ($("#txtManuscriptId").val() == '') {
      ngswal("Failed !", "Please update ManuscriptId", "error");
    }
    else if (
      $("#ddlUnsubmitted").val() == "Select" &&
      !["Problem", "Furture", "Pending"].includes($("#ddlStatus").val())
    ) {
      ngswal("Failed !", "Please select Unsubmitted", "error");
    }
    //else if ($("#ddlResubmit").val() == '0') {
    //  ngswal("Failed !", "Please select Resubmit", "error");
    //}
    else if ($("#ddlStatus").val() == 'Select') {
      ngswal("Failed !", "Please select Task Status", "error");
    }
    else if ($("#ddlStatus").val() == 'Problem' && $("#ddlReasonList").val() == 0) {
      ngswal("Failed !", "Please select Reason of Problem", "error");
    }
    else if (
      $("#ddlStatus").val() == "Problem" &&
      $("#txtNotes").val().trim() == ""
    ) {
      ngswal("Failed !", "Please select Reason of PRA Remarks", "error");
    }
    else if ($("#ddlUnsubmitted").val() == 'Yes' && $("#txtNotes").val() == '') {
      ngswal("Failed !", "Please update PRA Remarks", "error");
    }
    else if ($("#ddlReasonList").val() == '29' && $("#txtNotes").val() == '') {//Other (PRA to enter relevant remarks) - 29
      ngswal("Failed !", "Please update PRA Remarks", "error");
    }
    else if ($("#ddlStatus").val() == 'Completed' && $('#txtCompletionDate').val() == '') {
      ngswal("Failed !", "Please select Completion Date !", "error");
    }
    else if ($("#ddlStatus").val() == 'Saved' && $('#txtCompletionDate').val() == '') {
      ngswal("Failed !", "Please select Completion Date !", "error");
    }
    else if ($("#txtNotes").val() == '' && ($('#ddlStatus').val() == 'Late'
      || $('#ddlStatus').val() == 'Not Applicable' || $('#ddlStatus').val() == 'Future')) {
      ngswal("Failed !", "Please update PRA Remarks !", "error");
    }
    else if ($('#ddlFeedbackType').val() != "Select" && ($('#txtQcComments').val().trim() == "" || $('#txtFeedbackDate').val().trim() == "")) {
      ngswal("Failed !", "Please update Feedback details & Select Feedback Date !", "error");
    }
    else if ($('#txtQcComments').val().trim() != "" && ($('#ddlFeedbackType').val() == "Select" || $('#txtFeedbackDate').val().trim() == "")) {
      ngswal("Failed !", "Please select Feedback Type & Select Feedback Date !", "error");
    }
    else if ($('#txtFeedbackDate').val().trim() != "" && ($('#ddlFeedbackType').val() == "Select" || $('#txtQcComments').val().trim() == "")) {
      ngswal("Failed !", "Please select Feedback Type & Enter Feedback details !", "error");
    }
    else {
      $("#LoadingImage").show();
      var data = {
        Id: localStorage.aEID,
        PublisherId: $("#ddlPublisher").val(),
        JournalCode: $("#txtJournal").val(),
        ManuscriptId: $("#txtManuscriptId").val(),
        ManuscriptType: $("#txtManuscriptType").val(),
        ManuscriptTitle: $("#txtManuscriptTitle").val(),
        DownloadDate: $("#txtDownloadDate").val(),
        SubmissionDate: $("#txtSubmissionDate").val(),
        CompletionDate: $("#txtCompletionDate").val(),
        EntryMode: $("#ddlResubmit").val(),
        TaskName: $("#ddlTaskName").val(),
        TaskType: $("#ddlTaskType").val(),
        CurrentStatus: $("#ddlStatus").val(),
        Unsubmitted: $("#ddlUnsubmitted").val(),
        SubmittingAuthor: $("#txtSubmittingAuthor").val(),
        CountrySubmittingAuthor: $("#txtCountrySubmittingAuthor").val(),
        EditorInChief: $("#txtEditorInChief").val(),
        Editor: $("#txtEditor").val(),
        FeedbackType: $("#ddlFeedbackType").val(),
        FeedbackDate: $("#txtFeedbackDate").val(),
        AllocatedUserId: $("#ddlAllocatedUser").val(),
        QcComments: $("#txtQcComments").val(),
        Notes: $("#txtNotes").val(),
        QueryComments: $("#txtQueryComments").val(),
        ReasonId: $("#ddlReasonList").val(),
        UpdatedBy: localStorage.aLoginID,
      }

      ApiMethod.postMethod('api/updatepraservices', data).subscribe(
        response => {
          this.GetPraServices(this.ListTitle);
          this.GetSummartItem();
          if (response.status) {
            ngswal("info !", response.message, "info");
          }
          else {
            ngswal("Failed !", response.message, "error");
          }
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
  }

  clearData(): void {
    try {
      let form: NgForm = $('form#frmMain');
      form[0].reset();

    } catch (e) { }
  }

  ServicesUploadEvent() {
    $("#UploadServicesFile").trigger("click");
  }

  UploadServices = (files) => {
    if (files.length === 0) {
      return false;
    }
    let fileToUpload = <File>files[0];
    let ext = fileToUpload.name.toString().split('.').pop().toLowerCase();

    if ($.inArray(ext, ['xls', 'xlsx']) === -1) {
      $('#UploadServicesFile').val('');
      ngswal("Warning !", "Invalid file format. Please upload an Excel file!", "warning");
      return false;
    }

    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('ClientApiUrl', 'api/UploadExcelPRAServices');
    formData.append('LoginId', localStorage.aLoginID);
    formData.append('PublisherId', localStorage.aPubID);
    formData.append('ProcessType', "Upload");
    $("#LoadingImagePopup").show();

    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData).subscribe(
      (response: Response) => {

        let msgInfo = ''; let msgDetails = '';
        let result = $(response.headers);
        $.each(result, function (e, val) {
          if (val.key == 'ErrorMessage') {
            msgInfo = 'Warning';
            msgDetails = val.value.toString();
          }
          else if (val.key == 'SuccessMessage') {
            msgInfo = 'Success';
            msgDetails = val.value.toString();
          }
        });
        $('#UploadServicesFile').val('');
        if (msgInfo == 'Success') {
          this.ResetFilter();
        }
        ngswal(msgInfo, msgDetails, "info");

        $("#LoadingImagePopup").hide();
      },
      (error) => {
        console.log(error.message);    // Show error, if any.
        ngswal("Warning !", error.message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }


  TLAList: any; TaskNameList: any; CurrentStatusList: any;
  PRAsAllocatedlist: any; ChangeAllocatedList = [];
  ShowTaskAllocatedList() {
    this.ChangeAllocatedList = [];
    $('#divPopTitle').html(`${localStorage.praname} - Allocated Task`);

    $("#LoadingImage").show();

    var _manuscriptList = '';
    if ($("#ddlPopupManuscript").val() != null) {
      _manuscriptList = $("#ddlPopupManuscript").val().toString();
    }

    if ($('#ddlKPIMonthRange').val() == -1) {
      $('#txtPopupFromDt').val($('#txtFromDt').val());
      $('#txtPopupToDt').val($('#txtToDt').val())
    }

    var data = {
      LoginID: localStorage.aLoginID,
      PraName: localStorage.praname,
      FromDate: $('#txtPopupFromDt').val(),
      ToDate: $('#txtPopupToDt').val(),
      DateType: $("#ddlPopupDateType").val(),
      ManuscriptList: _manuscriptList,
      JournalCode: $("#ddlPopupJournal").val() ? $("#ddlPopupJournal").val().join(',') : "All",
      TaskName: $("#ddlPopupTaskName").val() ? $("#ddlPopupTaskName").val().join(',') : "All",
      CurrentStatus: $("#ddlPopupStatus").val() ? $("#ddlPopupStatus").val().join(',') : "All",
    };
    ApiMethod.postMethod('api/praallocatedlist', data).subscribe(
      result => {
        $("#LoadingImage").hide();

        if (!this.PRAsAllocatedlist || this.PRAsAllocatedlist.length === 0) {

          const data = result?.datalist ?? [];  // Safe-null handling
          this.PRAsAllocatedlist = data;

          if (data.length > 0) {
            this.TLAList = GlobalConstants.distinctBy('JournalCode', data);
            this.TaskNameList = GlobalConstants.distinctBy('TaskName', data);
            this.CurrentStatusList = GlobalConstants.distinctBy('CurrentStatus', data);
          } else {
            this.TLAList = [];
            this.TaskNameList = [];
            this.CurrentStatusList = [];
          }
        }

        this.dataSetPA = JSON.stringify(result.datalist); // Data List
        this.dataSetPA = JSON.parse(this.dataSetPA);
        this.dataTablePA = $(this.tablePA.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btnMultipleAllocate';
        dataItem.aNewButtonToolTip = 'Group Allocate';
        dataItem.colsetting = false;
        dataItem.dataTable = this.dataTablePA;
        dataItem.dataset = this.dataSetPA;
        dataItem.dtheight = (GlobalConstants.size.height - 350);
        dataItem.modulename = 'PRAAllocation';
        dataItem.infoPopupID = 'Id';
        dataItem.ExportFileName = `${localStorage.praname}_Allocated`;
        dataItem.StateSave = false;
        dataItem.defaultPagesize = -1;
        this.dataTablePA = customfunctions.dynamicDataTable(dataItem);


        $('#myModal_AllocatedTask').show();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

  }

  HideShowTaskAllocated() {
    this.PRAsAllocatedlist = null;
    $('#myModal_AllocatedTask').hide();
  }

  ChangeUserTaskAllocate(event: Event) {
    const selectElement = event.target as HTMLSelectElement;

    const selectedValue = selectElement.value;
    const selectedTtaskId = selectElement.getAttribute('data-id');

    // Check if task already exists
    const existingIndex = this.ChangeAllocatedList.findIndex(x => x.taskId === selectedTtaskId);

    if (existingIndex > -1) {
      this.ChangeAllocatedList.splice(existingIndex, 1);
    }
    this.ChangeAllocatedList.push({
      taskId: selectedTtaskId,
      allocatedUserId: selectedValue
    });
    console.log(this.ChangeAllocatedList);
  }

  TaskAllocated2User() {
    if (!this.ChangeAllocatedList || this.ChangeAllocatedList.length === 0) {
      ngswal("Info !", "No Task Allocated !", "warning");
      return;
    }
    $("#LoadingImage").show();
    var data = {
      LoginId: localStorage.aLoginID,
      TaskUserList: JSON.stringify(this.ChangeAllocatedList)
    };
    ApiMethod.postMethod('api/allocatetasktouser', data).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.PRAsAllocatedlist = result.datalist;
        if (result.status) {
          ngswal("info !", result.message, "info");
          this.ShowTaskAllocatedList();
          this.GetSummaryData('Summary');
          this.ChangeAllocatedList = [];
        }
        else {
          ngswal("Failed !", result.message, "error");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  AllocateSelecteTask() {
    if (localStorage.selectRowIdVal == "") {
      ngswal("Warning", "Please select task !", "warning");
      return;
    }
    $('#ddlpraNameGA').val(0).change();
    $('#myModalPRAGA').show();
  }

  AllocateConfirmation() {
    if ((localStorage.dropId === "1" || localStorage.dropId === "" || localStorage.dropId === "Select")
      && $("#ddlpraNameGA").val() === "0") {
      ngswal("Warning", "Please select PRA !", "warning");
      return;
    }

    ngswal({
      title: "Confirmation",
      text: "Do you want to Allocate ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnAllocateConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });

  }

  AllocatePRA(praId = 0, taskIdList = '') {
    // Check PRA dropdown
    const dropId = localStorage.dropId ?? '';
    if (dropId.trim() === '' || dropId === 'Select') {
      ngswal("Warning", "Please select PRA !", "warning");
      return;
    }

    // PRA ID fallback (if null/0/empty)
    if (!praId || praId === 0) {
      praId = dropId;
    }

    // Task list fallback (null/undefined/empty)
    if (!taskIdList || taskIdList.trim() === '') {
      taskIdList = localStorage.aEID ?? '';
    }

    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });

    $("#LoadingImage").show();

    if (praId == -1) {
      praId = null;
    }
    const data = {
      LoginId: localStorage.aLoginID,
      AllocatedUserId: praId,
      TaskIdList: taskIdList
    };

    ApiMethod.postMethod('api/allocatetasktouser', data).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.PRAsAllocatedlist = result.datalist;

        if (result.status) {
          ngswal("info !", result.message, "info");
          this.ShowTaskAllocatedList();
          this.GetSummaryData('Summary');
          this.ChangeAllocatedList = [];

          $('#myModalPRAGA').hide();
          localStorage.dropId = "";
          $('#ddlpraNameGA').val(0).change();
        }
        else {
          ngswal("Failed !", result.message, "error");
        }
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  hidePRAGP() {
    $('#myModalPRAGA').hide();
  }

  message: string = '';
  GroupAllocation() {
    this.message = ''
    if ($('#ddlpraNameGA').val() == 0) {
      this.message = 'Please select PRA'
      return;
    }
    this.AllocatePRA($('#ddlpraNameGA').val(), localStorage.selectRowIdVal);
  }


  ResetPopupFillter() {

    customfunctions.SetCurrentMonthDateValues("#txtPopupFromDt", "#txtPopupToDt");
 
    $('#ddlPopupDateType').val('DownloadDate').change();
    [
      '#ddlPopupJournal',
      '#ddlPopupTaskName',
      '#ddlPopupStatus',
      '#ddlPopupManuscript'
    ].forEach(id => {
      $(id).val([]).trigger('change');
    });
    this.ShowTaskAllocatedList();
  }
}
